import {useEffect, useState, useRef, LegacyRef, useCallback} from 'react';
import { DanceItem } from './DanceItem';
import DanceItemComp from './DanceItemComp';
import  ReactPlayer from 'react-player';
import axios, {  } from 'axios';
import config from '../Config';
import { useNavigate, useParams } from 'react-router-dom';
import VideoComponent from './VideoComponent';

const Page_Index = () => {
  
  const playerRef = useRef<ReactPlayer>(null);
  const startTimeRef = useRef<number>(0);

  const isReady = useRef(false);

  const [items, setItems] = useState<DanceItem[]>([]);
  const [videoUrl, setVideoUrl] = useState<string>("");
  const [selectedId, setSelectedId] = useState<number>(-1);
  const navigate = useNavigate();

  useEffect(() => {
        const abortController = new AbortController();
    getItemsAsync(abortController)
    return () => {
        abortController.abort();
      };
  }, []);

  const onReady = useCallback(() => {
    if (playerRef.current ===null){
      return;
    }
    if (!isReady.current) {
      playerRef.current.seekTo(startTimeRef.current, 'seconds');
      isReady.current = true;
    }
  }, [isReady]);


  const getItemsAsync = async (abortController:AbortController) => {

    try {
      //let axiosRequestConfig = await context.getAxiosRequestObjectAsync(abortController);
      //axiosRequestConfig.params = {"id":id}

      var result = await axios.get<DanceItem[]>(config.backEndApi + `/api/GetDanceItems`/*, axiosRequestConfig*/);

      if (result.status !== 200) {
        console.log("Error in getItemsAsync, status is not 200");
        return;
      }

      console.log(result?.data);
      //setPlayList(result.data);
    
    // this should become an api-call
    /*let data = [
      new DanceItem ({
        id:0,
        source: "Dewi&Erwin",
        date: new  Date(2025,0,24),
        name:"Slingshot",
        description:"Begint met 2 handen laag\nOp 2 armen wijd, dicht bij de dame; Op 3 moet er geslingd zijn",
        videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20250124.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
  }),
      new DanceItem ({
        id:1,
        source: "Anja&Daniel",
        date: new  Date(2025,0,19),
        name:"Pingpong",
        description:"Begint met een slingshot op de schouder",
        videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/wcs20250119.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
        
      }),
      new DanceItem ({
        id:3,
        source: "Anja&Daniel",
        date: new  Date(2025,0,26),
        name:"Whip variations",
        description:"Whip telkens met draai op 5&6. (dus na rock-step nog 4 tellen)\n1/ to rock&go met inside turn\n2/ met doordraaienbeweging: 8 tellen whip; doordraaien is 6 tellen\n3/ met hand aan de rug (opgelet: laatsta deel is slechts 4 tellen)",
        videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/wcs20250126.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
      }),
      new DanceItem ({
        id:4,
        source: "Dewi&Erwin",
        date: new  Date(2025,0,31),
        name:"Blind man whip ",
        description:"Aka behind the back whip (Handwissel op 2 - op 56 inside turn dame)\nGevolgd door: Sugarpush Caresse\n Hustle check: 1:achter 2:voor en prep, 3 achter en arm op schouder en 4 achter, dame triple + uit draaien\nEn dan een sunshine sugarpush",
        videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/20250131_221514.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
        
      }),
    new DanceItem ({
      id:5,
      source: "Anja&Daniel",
      date: new  Date(2025,1,2),
      name:"Sweep-elaborate version",
      description:"Een sweep, maar met hopjes (5 tot 8).Op 78 sliden naar close position.\n 1, e naar achter, op 3 dame draaien; op 4 moet he aan de andere kant staan. Dan op 5&6 doordraaien, en dan achor \nAllemaal stappen)",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20250202.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:6,
      source: "Dewi&Erwin",
      date: new  Date(2025,1,7),
      name:"Lazy tuck (+variations)",
      description:"2 naar voor",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20250207.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:7,
      source: "Anja&Daniel",
      date: new  Date(2025,0,12),
      name:"Schouderblad slingshot",
      description:"",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/wcs20250112.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:8,
      source: "Dewi&Erwin",
      date: new  Date(2025,1,7),
      name:"Tucks",
      description:"Gewoon&lazy",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20250207.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:9,
      source: "J&N",
      date: new  Date(2025,0,10),
      name:"Hustle whip",
      description:"Rechts bove, links onder",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20250110.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:10,
      source: "Anja&Daniel",
      date: new  Date(2024,9,13),
      name:"Rock 'n go",
      description:"Double handed left lide pass met tuckturn to get is started",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20241013.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:11,
      source: "Anja&Daniel",
      date: new  Date(2024,9,6),
      name:"Car wash",
      description:"Whip as the start",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20241006.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:12,
      source: "Anja&Daniel",
      date: new  Date(2025,1,9),
      name:"Titanic",
      description:"Stap achter, handwissel, point voet en verzet gewicht.\nvergeet niet om een draai te leiden",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/WCS20250209.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:13,
      source: "Anja&Daniel",
      date: new  Date(2025,1,16),
      name:"Bondage",
      description:"Double handed left met indraaien",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/20250216D&A.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),
    new DanceItem ({
      id:14,
      source: "Dewi&Erwin",
      date: new  Date(2025,1,21),
      name:"Arm hooks",
      description:"Double handed left met indraaien",
      videoUrl:"https://triondancedataprod.blob.core.windows.net/videos/20250221.mp4?sv=2023-01-03&st=2025-03-08T11%3A21%3A22Z&se=2025-04-09T10%3A21%3A00Z&sr=c&sp=rl&sig=U7o2aaXPqOCYxzjoXeaKhu%2Faao%2F8uCnTc%2FPWE9dby30%3D",
    }),

    new DanceItem ({
      id:15,
      source: "Youtube",
      date: new  Date(2025,1,26),
      name:"Slingshot and whip",
      description:"Double handed slingshot\nBij terug draaien, zorg dat je met links al in het slot staat",
      videoUrl:"https://www.youtube.com/watch?v=yqvtBopdCVs",
      startTimeInSeconds:250
    }),


    //

      // telemark with inside turns
      //https://www.youtube.com/watch?v=Ae9OTEZ60yY
      
    ];
*/
    setItems([...result.data]);

    //let filterValues =  [...new Set(result.data.map(item => item.source))];
    //console.log(filterValues);
  }
  catch {
    console.log("Error in getItemsAsync");

  }
  }


  const handleVideoClicked = (id:number, startTimeInSeconds:number)=> {
    
    var item = items.find(i => i.id == id);
    if (item === undefined) {
      console.log("That's unexpexted, item not found");
      return;
  }
    setSelectedId(id);
    startTimeRef.current = startTimeInSeconds;
    //console.log(startTimeRef.current)
    isReady.current = false;

    setVideoUrl(item.videoUrlForDisplay);

  }

  const handleAddClicked = ()=> {
    navigate('/Add');
  }
/*
  sort((a, b) => {
    if (a.date ===  b.date) return 0;
    if (a.date <  b.date) return -1
    return 1;
  }).*/

//src="https://www.facebook.com/plugins/video.php?height=476&href=https%3A%2F%2Fwww.facebook.com%2Freel%2F643968231711656%2F&show_text=false&width=267&t=0"

    return(
        <div>
          {videoUrl.length > 0 && <div className="">
                <VideoComponent url={videoUrl} startTimeInSeconds={0} />
            </div>
          }
          <br></br>
          <div className="flex flex-wrap">
            <button className='w-10 h-10 bg-blue-300 hover:bg-blue-600 text-white rounded-full flex items-center justify-center text-xl transition-colors shadow-md hover:shadow-lg' onClick={handleAddClicked}>+</button>
            {
              items.sort((a, b) => {
                if (a.date ===  b.date) return 0;
                if (a.date >  b.date) return -1
                return 1;
              }).map((item, index) => (
                <div key={`${index}`} className='basis-40'>
                  <DanceItemComp  danceItem={item} isSelected={selectedId===item.id} onClick={handleVideoClicked}></DanceItemComp>
                  <br></br>
                </div>
            ) )
            }
          </div>
        </div>
    );
}

export default Page_Index;